export enum ScreenWidths {
  SMALL_SCREEN = 600
}
